import { isValidDateString, isValidTimeString } from "@/common/utils/dateValidator";
import { unFormatUnknownUnit } from "@/common/utils/unFormatters";
import z from "zod";
import { MaintenanceForwardingEstablishmentChoiceEntryKlass } from "../../types/forwardings/establishmentChoiceEntries/establishmentChoiceEntry.type";


export const establishmentChoiceEntrySchema = z.discriminatedUnion(
  'establishment_choice_entry_type',
  [
    z.object({
      establishment_choice_entry_type: z.literal(
        MaintenanceForwardingEstablishmentChoiceEntryKlass.ManualEntry
      ),
      establishment_choice_entry_attributes: z.object({
        establishment_id: z.string(),
      }),
    }),
    z.object({
      establishment_choice_entry_type: z.literal(
        MaintenanceForwardingEstablishmentChoiceEntryKlass.AuctionEntry
      ),
      establishment_choice_entry_attributes: z.object({
        minimum_of_proposals_to_finish: z.string().refine(unFormatUnknownUnit),
        allowance_radius_in_kilometers: z.string().refine(unFormatUnknownUnit),
        finishes_at_date: z.string().refine(isValidDateString),
        finishes_at_time: z.string().refine(isValidTimeString),
      }),
    }),
  ]
);

export type EstablishmentChoiceEntryValidationSchema = z.infer<typeof establishmentChoiceEntrySchema>;

export type EstablishmentChoiceEntryManualEntrySchema = Extract<
  EstablishmentChoiceEntryValidationSchema,
  { establishment_choice_entry_type: 'Maintenance::EstablishmentChoice::ManualEntry' }
>;

export type EstablishmentChoiceEntryAuctionEntrySchema = Extract<
  EstablishmentChoiceEntryValidationSchema,
  { establishment_choice_entry_type: 'Maintenance::EstablishmentChoice::AuctionEntry' }
>;
